import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
// Forms
import { reduxForm, getFormValues } from "redux-form";
// i18n
import { withNamespaces } from "react-i18next";
// Ducks
import { fetchAppFeatureSettings } from "../../../services/clientSettings.ducks";
import { fetchProfile } from "../../../services/auth.ducks";
import { changeProfile } from "./Settings.ducks";
import { setNotification } from "../../../components/SmartNotification/SmartNotification.ducks";
// Components
import Form from "../../../components/Form";
import ProfileFields from "../../../components/ProfileFields";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableUserDataEdit: true,
      profile: props.profile,
      locales: props.locales,
      isoCountries: props.isoCountries
    };
  }

  componentDidMount() {
    const {
      fetchProfile
    } = this.props;

    this.getAppFeatureSettings();
    fetchProfile();
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(nextProps.profile);
  }

  async getAppFeatureSettings() {
    const { fetchAppFeatureSettings } = this.props;
    const appFeatureSettings = await fetchAppFeatureSettings();

    this.setState({
      enableUserDataEdit: appFeatureSettings.enableUserDataEdit
    });
  };

  isButtonEnabled = () => {
    const { formValues, profile } = this.props;

    const oldProfile = JSON.stringify(profile);
    const newProfile = JSON.stringify(formValues);

    return oldProfile === newProfile;
  };

  getPreferredCommunicationLanguageOptions = () => {
    const { locales } = this.state;
    const options = [];

    locales.forEach((locale) => {
      options.push({
        key: locale.locale,
        value: locale.localeName
      });
    });

    options.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });

    return options;
  };

  getIsoCountryOptions = () => {
    const { t } = this.props;
    const { isoCountries } = this.state;
    const options = [];

    isoCountries.forEach((isoCountry) => {
      options.push({
        key: isoCountry.isoCountryAlpha3,
        value: t(isoCountry.nameL10n)
      });
    });

    options.sort((a, b) => {
      return a.value.localeCompare(b.value);
    });

    return options;
  };

  onSubmit = (values) => {
    const { changeProfile } = this.props;

    changeProfile(values);
  };

  render() {
    const { handleSubmit, t } = this.props;
    const { enableUserDataEdit } = this.state;

    return (
      <div
        className="container"
        style={{
          marginTop: 50
        }}
      >
        <Form
          bootStrapClass="col-sm-12 well no-padding"
          buttonDisabled={this.isButtonEnabled()}
          buttonText={t("modules.localization.register.authenticated.settings.button.update")}
          handleSubmit={handleSubmit}
          onSubmit={this.onSubmit}
          title={t("modules.localization.register.authenticated.settings.updateDetails")}
        >
          <ProfileFields
            fieldNames={{
              birthDate: t("modules.localization.register.authenticated.settings.birthDate"),
              city: t("modules.localization.register.authenticated.settings.city"),
              isoCountryAlpha3: t("modules.localization.register.authenticated.settings.country"),
              preferredCommunicationLocaleCode: t("modules.localization.register.authenticated.settings.emailLanguage"),
              firstName: t("modules.localization.register.authenticated.settings.firstName"),
              lastName: t("modules.localization.register.authenticated.settings.lastName"),
              postalCode: t("modules.localization.register.authenticated.settings.postalCode"),
              street: t("modules.localization.register.authenticated.settings.street"),
              street2: t("modules.localization.register.authenticated.settings.street2")
            }}
            languagesOptions={this.getPreferredCommunicationLanguageOptions()}
            isoCountryOptions={this.getIsoCountryOptions()}
            options={{ enableUserDataEdit: enableUserDataEdit }}
          />
        </Form>
      </div>
    );
  }
}

const formPropTypes = PropTypes.shape({
  availableLanguages: PropTypes.arrayOf(PropTypes.string),
  availableIsoCountries: PropTypes.arrayOf(PropTypes.object),
  city: PropTypes.string,
  isoCountryAlpha3: PropTypes.string,
  email: PropTypes.string,
  emailLanguage: PropTypes.string,
  firstName: PropTypes.string,
  id: PropTypes.number,
  isActive: PropTypes.bool,
  isPasswordIntendedToChange: PropTypes.bool,
  isProfileIntendedToApprove: PropTypes.bool,
  isUserActive: PropTypes.bool,
  lastName: PropTypes.string,
  passwordPolicy: PropTypes.shape({
    allowedSpecialCharacters: PropTypes.string,
    forbiddenSpecialCharacters: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    needNumericCharacters: PropTypes.bool,
    needSpecialCharacters: PropTypes.bool,
    needUppercaseCharacters: PropTypes.bool
  }),
  postcode: PropTypes.string,
  street: PropTypes.string,
  streetNumber: PropTypes.string
});

Settings.propTypes = {
  changeProfile: PropTypes.func.isRequired,
  fetchAppFeatureSettings: PropTypes.func.isRequired,
  fetchProfile: PropTypes.func.isRequired,
  formValues: formPropTypes,
  handleSubmit: PropTypes.func.isRequired,
  profile: formPropTypes,
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  initialValues: state.auth.profile.email ? state.auth.profile : undefined,
  formValues: getFormValues("settings")(state),
  profile: state.auth.profile,
  locales: state.localization.locales,
  isoCountries: state.internationalization.isoCountries
});

const mapDispatchToProps = {
  changeProfile,
  fetchAppFeatureSettings,
  fetchProfile,
  setNotification
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: "settings"
  }),
  withNamespaces()
)(Settings);
